import React from "react";
import { BasicChequeredBoard } from "../../components/BasicChequeredBoard";
import { BasicChequeredBoardProps } from "../../components/BasicChequeredBoard/BasicChequeredBoard";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { GroupedComponents } from "../../components/GroupedComponents";
import { Links, LinksProps } from "../../components/Links";
import { List } from "../../components/List";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { GenericListProps } from "../../types/GenericListType";

export interface ElectricityChangesPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  chequeredBoard?: BasicChequeredBoardProps;
  lists?: GenericListProps[];
  linksList?: LinksProps[];
  faqs?: FaqAccordionGroupProps;
}

export const ElectricityChangesPage: React.FC<ElectricityChangesPageProps> = ({
  seo,
  pageTitle,
  paragraphs,
  chequeredBoard,
  lists,
  linksList,
  faqs,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
      {chequeredBoard && <BasicChequeredBoard {...chequeredBoard} />}
      <GroupedComponents>
        {paragraphs && paragraphs[1] && <Paragraph {...paragraphs[1]} />}
        {lists && lists[0] && <List {...lists[0]} />}
      </GroupedComponents>
      {linksList && linksList[0] && <Links {...linksList[0]} />}
    </ServiceCataloguePageWrapper>
  );
};
